export default __webpack_public_path__ + "static/media/terms.5cf006a4.pdf";